__webpack_require__.p = "https://bikapi.bikayi.app/assets/bap/";